import {
  normalizeCountry,
  normalizeState,
} from "../../../utils/filterNormalization";

export { downloadBlobFile } from "../../../utils/download";

export const normalizePipelineStageFilter = (value) => {
  if (!value || value === "null") {
    return "";
  }

  return value;
};

const formatCountryLabel = (value) => normalizeCountry(value);
const formatStateLabel = (value) => normalizeState(value);
export const formatLocationLabel = ({ city, state, country }) => {
  const parts = [
    city?.trim?.(),
    formatStateLabel(state),
    formatCountryLabel(country),
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(", ") : "—";
};

export const getProspectingCompanyWebsiteUrl = (website) =>
  website?.startsWith("http") ? website : `https://${website}`;
